import React from 'react';

import './style.sass';
import ScrollAnimation from '../../../../../../../core/ScrollAnimation';

function Goal() {
    return (
        <div className="skolkovo-kids__goal">
            <div className="skolkovo-kids__goal-inner">
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="skolkovo-kids__goal-title">Цель</div>
                </ScrollAnimation>
                <ScrollAnimation animateIn="fadeInUp" offset={100} animateOnce={true} duration={1}>
                    <div className="skolkovo-kids__goal-text">
                        настроить продвижение нового сообщества в&nbsp;социальной сети
                        &laquo;ВКонтакте&raquo; для привлечения целевых подписчиков в&nbsp;группу.
                    </div>
                </ScrollAnimation>
                <div className="skolkovo-kids__goal-wrapper">
                    <img
                        className="skolkovo-kids__goal-img"
                        src="/images/pic/skolkovo-kids/goal.png"
                        alt="goal"
                    />
                </div>
            </div>
        </div>
    );
}

export default Goal;
